import { getInitialStateFromConfig } from "helpers/form";

const config = {
    considerCurrentLocation: {
        // checkbox
        label: "Учитывать текущее местоположение машины",
        inputProps: { name: "considerCurrentLocation" },
        type: "checkbox",
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
